import { render, staticRenderFns } from "./WorkDeskMenuPage.vue?vue&type=template&id=536346a1&scoped=true"
import script from "./WorkDeskMenuPage.vue?vue&type=script&lang=js"
export * from "./WorkDeskMenuPage.vue?vue&type=script&lang=js"
import style0 from "./WorkDeskMenuPage.vue?vue&type=style&index=0&id=536346a1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "536346a1",
  null
  
)

export default component.exports